import styled from 'styled-components';
import { breakpoints } from "@tvg/design-system";

export const DesktopFdrVideoWrapper = styled.div`
    max-width: 770px;
    
    @media screen and ${breakpoints.tablet.min.sm} {
        margin: 0 auto;
        width: 100%;
  }
`;